export const visit = (vm, at) => {
at({ "da": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "Ny besked" } } });
};